import React from "react";
import { Server, ShieldCheck, Laptop, ScanBarcode, Video, Rocket, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const expertiseData = [{
  title: "Infrastrutture IT",
  icon: Server,
  bullets: ["Architetture infrastrutturali", "Sistemi cloud ibridi", "Ottimizzazione ambienti infrastrutturali"],
  link: "/ServicesPage"
}, {
  title: "Cybersecurity",
  icon: ShieldCheck,
  bullets: ["Protezione endpoint", "Strategie di backup e recovery", "Autenticazione multi-fattore (MFA)"],
  link: "/ServicesPage"
}, {
  title: "Dispositivi Aziendali",
  icon: Laptop,
  bullets: ["Gestione dispositivi end-user", "Supporto tecnico utenti", "Provisioning e configurazione dispositivi"],
  link: "/ServicesPage"
}, {
  title: "Tecnologie Logistiche",
  icon: ScanBarcode,
  bullets: ["Terminali RF e dispositivi handheld", "Stampanti termiche e sistemi barcode ", "Integrazione tecnologie di magazzino"],
  link: "/SolutionsPage"
}, {
  title: "Strumenti di Collaborazione",
  icon: Video,
  bullets: ["Sale riunioni digitali", "Sistemi di videoconferenza", "Piattaforme collaborative"],
  link: "/ServicesPage"
}, {
  title: "Deployment",
  icon: Rocket,
  bullets: ["Rollout su larga scala", "Pianificazione migrazioni", "Gestione ciclo di vita asset"],
  link: "/ServicesPage"
}];
export default function CoreExpertise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="core-expertise" ref={ref} className="dark bg-background text-foreground py-24 relative overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.03]" style={{
      backgroundImage: `radial-gradient(circle at 2px 2px, var(--color-primary) 1px, transparent 0)`,
      backgroundSize: '40px 40px'
    }} />
      
      <div className="container mx-auto px-4 relative z-10">
        <div className={`max-w-3xl mb-16 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <h2 className="text-primary font-mono text-sm tracking-wider uppercase mb-4">
            Competenze Tecniche
          </h2>
          <h3 className="text-4xl md:text-5xl font-bold tracking-tight text-white mb-6">Precisione Tecnica.<br />Affidabilità Operativa.</h3>
          <p className="text-muted-foreground text-lg max-w-2xl">Supporto tecnico per infrastrutture critiche,&nbsp;<span style={{
            color: 'rgb(148, 163, 184)',
            letterSpacing: '-0.32px'
          }}>ambienti logistici e postazioni di lavoro.&nbsp; &nbsp; &nbsp;Un approccio rigoroso orientato a continuità operativa e sicurezza.</span></p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {expertiseData.map((item, i) => <Link key={i} to={item.link} className="block h-full group outline-none" data-index={i}>
              <Card className={`
                  h-full bg-card/5 border-white/10 backdrop-blur-sm transition-all duration-500
                  hover:border-primary/50 hover:bg-card/10 hover:shadow-[0_0_30px_-10px_var(--color-primary)]
                  ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}
                `} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                <CardHeader className="pb-2">
                  <div className="flex justify-between items-start">
                    <div className="p-3 rounded-lg bg-primary/10 text-primary mb-4 group-hover:bg-primary/20 transition-colors">
                      <item.icon className="w-8 h-8" strokeWidth={1.5} />
                    </div>
                    <div className="opacity-0 -translate-x-4 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 text-primary">
                      <ArrowRight className="w-6 h-6" />
                    </div>
                  </div>
                  <CardTitle className="text-xl font-bold text-white group-hover:text-primary transition-colors">
                    {item.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <ul className="space-y-2">
                    {item.bullets.map((bullet, idx) => <li key={idx} className="flex items-center text-sm text-muted-foreground group-hover:text-gray-300 transition-colors">
                        <span className="w-1.5 h-1.5 rounded-full bg-primary/50 mr-2 group-hover:bg-primary transition-colors" />
                        {bullet}
                      </li>)}
                  </ul>
                </CardContent>
              </Card>
            </Link>)}
        </div>
      </div>
    </section>;
}